import styled from 'styled-components/macro';
import { SVGIcon } from '@yme/atoms/svg-icon';
import { colorCoreGray300, colorCoreGray500 } from '@yme/tokens/colors';
import { INDENT } from '@yme/tokens/sizes';
export const DownloadSectionStyled = styled.div `
  width: 100%;
  background: ${colorCoreGray300};
  border: 1px solid ${colorCoreGray500};
  padding: ${INDENT.sm};
`;
export const SVGIconStyled = styled(SVGIcon) `
  width: ${INDENT.sm};
  ${({ isRightToLeft }) => isRightToLeft ? `margin-left: ${INDENT.xxxxs}` : `margin-right: ${INDENT.xxxxs}`}
`;
